import { Item, validateItem } from "../item/Item.js";
import { createCachedFunction } from "../../utils/cacheUtils.js";
import { EntrySummary } from "./EntrySummary.js";
import { extractMonth } from "../../../../packages/date/dateFunctions.js";
import {
  createArrayValidator,
  createObjectValidator,
  validateString,
  validateUuidV4
} from "../../../../packages/validator/validator.js";
import { getMonthName } from "../date/getMonthName.js";

/**
 * One accounting entry (transaction).
 */
export type Entry = {
  /**
   * Entry ID.
   */
  id: string;
  /**
   * Title of the entry.
   */
  title: string;
  /**
   * Items of the entry.
   */
  items: Item[];
};

export const validateEntry = createObjectValidator<Entry>("Entry", {
  id: validateUuidV4,
  title: validateString,
  items: createArrayValidator(validateItem)
});

/**
 * Finds earliest date from the entry items. Returns
 * 9999-99-99 when no entry exists. This function is cached.
 */
export const findEarliestDate = createCachedFunction((entry: Entry) => {
  let earliest = "9999-99-99";
  for (const item of entry.items) {
    if (item.date < earliest) {
      earliest = item.date;
    }
  }
  return earliest;
});

export type MonthEntries = {
  monthName: string;
  entries: EntrySummary[];
};

/**
 * Groups given entries by month.
 */
export const groupByMonth = (entries: EntrySummary[]) => {
  const months: MonthEntries[] = [
    {
      monthName: getMonthName("01"),
      entries: []
    },
    {
      monthName: getMonthName("02"),
      entries: []
    },
    {
      monthName: getMonthName("03"),
      entries: []
    },
    {
      monthName: getMonthName("04"),
      entries: []
    },
    {
      monthName: getMonthName("05"),
      entries: []
    },
    {
      monthName: getMonthName("06"),
      entries: []
    },
    {
      monthName: getMonthName("07"),
      entries: []
    },
    {
      monthName: getMonthName("08"),
      entries: []
    },
    {
      monthName: getMonthName("09"),
      entries: []
    },
    {
      monthName: getMonthName("10"),
      entries: []
    },
    {
      monthName: getMonthName("11"),
      entries: []
    },
    {
      monthName: getMonthName("12"),
      entries: []
    }
  ];
  for (const entry of entries) {
    const month = extractMonth(entry.date);
    months[month].entries.push(entry);
  }
  return months.filter((month) => month.entries.length > 0).reverse();
};
